import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../../components/organisms/Footer/footer";
import CookieConsent from "../../components/organisms/CookieConsent/cookie-consent";
import {
  CookieConsentProvider,
  useCookieConsent,
} from "../../privacy/CookieConsentContext";
import { initializeAnalytics, sendPageView } from "../../privacy/analytics";

function Analytics() {
  const location = useLocation();
  const { preferences } = useCookieConsent();

  useEffect(() => {
    if (!preferences.analytics) return;

    initializeAnalytics();
    sendPageView(
      `${location.pathname}${location.search}${location.hash}`
    );
  }, [location.hash, location.pathname, location.search, preferences.analytics]);

  return null;
}

function App({ children }) {
  return (
    <CookieConsentProvider>
      <Analytics />
      <div style={{ background: "#0d1625" }}>
        <main>{children}</main>
        <Footer />
      </div>
      <CookieConsent />
    </CookieConsentProvider>
  );
}

export default App;
